import React from 'react';
import PropTypes from 'prop-types';
import { HeaderWrapper, MainContent, Footer } from '@layout/PageTemplate';
import colors from '@theme/colors';
import { BasicPage, FlexContainer, FlexPadding } from '@layout';
import { Header, Sidebar } from '@organisms';

const OrganizationsPageTemplate = ({ children, title }) => (
  <BasicPage>
    <FlexContainer color={colors.WHITE}>
      <Sidebar />
      <FlexContainer vertical width="100%" height="100vh">
        <HeaderWrapper>
          <Header title={title} />
        </HeaderWrapper>
        <FlexPadding>
          <MainContent>{children}</MainContent>
        </FlexPadding>
        <Footer />
      </FlexContainer>
    </FlexContainer>
  </BasicPage>
);

OrganizationsPageTemplate.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  subheader: PropTypes.element,
};

export default OrganizationsPageTemplate;



// WEBPACK FOOTER //
// ./components/templates/OrganizationsPageTemplate/OrganizationsPageTemplate.js